* {
  box-sizing: border-box;
}

:host {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  padding-top: 60px;
  color: var(--cwc-color-white, #fff);
  background-repeat: no-repeat;
  background-position: 100% 0;
  background-color: var(--cwc-color-secondary, #333F48);
}

:host(.hidden) {
  display: none;
}

.title-container {
  position: relative;
  margin-bottom: 50px;
  padding: 0 24px;
  text-align: center;
}

.button-close {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent;
  border-radius: 100%;
  border: 3px solid rgba(173,178,181,0.3);
  cursor: pointer;
}

.button-close svg {
  width: 18px;
  height: 18px;
}

.button-close svg path {
  fill: var(--cwc-color-white, #fff);
}

.title {
  margin-top: 40px;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-size: 24px;
  font-weight: 400;
}

.description {
  color: var(--cwc-color-secondary-400, #A3AAAD);
}

.regions {
  width: 100%;
  max-width: 1140px;
  padding: 0 24px;
  text-align: center;
}

.region {
  margin-bottom: 30px;
}

.region-title {
  margin: 0;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: var(--language-region-color);
  cursor: pointer;
}

.region-title span {
  display: inline-block;
  width: 16px;
  height: 32px;
  margin-left: 8px;
  pointer-events: none;
}

.region-title[data-open="true"] span {
  transform: rotate(180deg);
}

.region-title svg {
  pointer-events: none;
}

.countries {
  height: 0;
  overflow-y: hidden;
  list-style-type: none;
  margin-top: 8px;
  padding: 0;
}

.region-title[data-open="true"] + .countries {
  height: unset;
}

.country {
  display: flex;
  flex-direction: column;
  margin-top: 0;
}

.country:not(:first-child) {
  margin-top: 15px;
}

.country-name {
  color: var(--cwc-color-secondary-050, #F2F2F2);
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold');
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 0;
  line-height: 1.2;
}

.languages {
  display: flex;
  justify-content: center;
  color: var(--cwc-color-secondary-400, #A3AAAD) !important;
  font-family: var(--cwc-font-sans-serif-regular, 'Eina01-Regular');
  font-size: 16px;
  line-height: 1.2;
}

.language {
  margin-top: 4px;
}

.language, .language:visited {
  color: var(--cwc-color-secondary-400, #A3AAAD) !important;
  text-decoration: none;
}

.language:hover {
  text-decoration: underline;
}

.additional-details {
  width: 100%;
  margin-top: 30px;
  border: 2px solid var(--cwc-color-secondary-800, #5A6973);
  border-left: 0;
  border-right: 0;
  font-size: 14px;
  text-align: left;
  color: var(--cwc-color-secondary-600, #7B858B);
}

.additional-details-inner {
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 24px;
}

.additional-details a,
.additional-details a:visited {
  color: var(--cwc-color-secondary-400, #A3AAAD);
}

@media (min-width: 768px) {
  :host {
    height: fit-content;
  }

  .title-container {
    text-align: left;
    padding: 0 148px 0 48px;
  }

  .button-close {
    position: absolute;
    top: 0;
    right: 48px;
  }

  .title-container {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
  }

  .title {
    margin: 0;
    font-size: 36px;
  }

  .description {
    font-size: 20px;
    line-height: 1.5;
  }

  .regions {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 2rem;
    padding: 0 48px;
    text-align: left;
  }

  .region-group:last-child {
    grid-column: span 3;
    max-width: 600px;
  }

  .region-title span {
    display: none;
  }

  .countries {
    height: unset;
    overflow-y: unset;
  }

  .region-group:last-child .countries {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .languages {
    justify-content: left;
  }

  .country {
    margin-top: 15px;
  }

  .additional-details-inner {
    padding-left: 48px;
    padding-right: 48px;
  }
}

@media (min-width: 1025px) {
  .title-container {
    padding-left: 64px;
    padding-right: 164px;
  }

  .button-close {
    right: 64px;
  }

  .regions,
  .additional-details-inner {
    padding-left: 64px;
    padding-right: 64px;
  }
}
